import { createSelector } from 'reselect'

const selectorFactory = (walletBannersSelector) => (whitelistedNavigationPaths) =>
  createSelector(walletBannersSelector, (walletBanners) =>
    walletBanners.find((banner) =>
      whitelistedNavigationPaths.includes(banner.walletBanner.navigationPath)
    )
  )

const createFirstWalletBannerSelector = {
  id: 'createFirstWalletBanner',
  selectorFactory,
  dependencies: [{ selector: 'walletBanners' }],
}

export default createFirstWalletBannerSelector
